import { Route } from '@/app/router'
import QuantityDisabled from '@/middleware/QuantityDisabled'

const GroupedSaleDraft = () => import('./index.vue')

const GroupedSaleDraftProps = ['page', 'perPage']

export default new Route('/grouped-sales-drafts/:id', GroupedSaleDraft)
	.as('Dashboard:GroupedSaleDraft')
	.props(GroupedSaleDraftProps)
	.permissions(['VIEW_GROUPED_SALE', 'PARTS_QUANTITY_DISABLED', 'PROCESS_VIN'])
	.middlewares(QuantityDisabled)
